import Container from "./Container";
export default function Section({ id, title, eyebrow, lead, children, className = "" }) {
    return (
        <section id={id} className={`py-12 sm:py-16 lg:py-20 ${className}`}>
            <Container>
                {(eyebrow || title || lead) && (
                    <header className="mb-8">
                        {eyebrow && <p className="text-xs uppercase tracking-wider text-brand-600 mb-2">{eyebrow}</p>}
                        {title && <h2 className="text-2xl sm:text-3xl font-bold">{title}</h2>}
                        {lead && <p className="mt-2 text-slate-600 dark:text-slate-300">{lead}</p>}
                    </header>
                )}
                {children}
            </Container>
        </section>
    );
}
